import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type SimilarCards as SchemaSimilarCards } from '../schemas/SimilarCards';
import { type SimilarCardsUpdateCommand as SchemaSimilarCardsUpdateCommand } from '../schemas/SimilarCardsUpdateCommand';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SimilarCards
 * @summary Обновить настройки похожих карточек для карточки товара
 */
export const UpdateSimilarCardsContentType = 'application/json' as const;
export type UpdateSimilarCardsRequest = SchemaSimilarCardsUpdateCommand;
export type UpdateSimilarCardsResponses = LinkCommonErrorResponses & {
    /**
     * @description Настройки обновлены
     */
    '200': {
        'application/json': SchemaSimilarCards;
    };
    /**
     * @description Настройки не найдены
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type UpdateSimilarCardsResponseSuccess = UpdateSimilarCardsResponses['200']['application/json'];
export type UpdateSimilarCardsSearchParams = undefined;
export type UpdateSimilarCardsPathParameters = {
    card_id: string;
};
export const UpdateSimilarCardsUrl = '/cards/{card_id}/similar-cards' as const;
export const UpdateSimilarCardsMethod = 'PATCH' as const;
export const getUpdateSimilarCardsUrl = (params: UpdateSimilarCardsPathParameters) =>
    UpdateSimilarCardsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateSimilarCardsPathParameters) =>
        String(params[param])
    );
